document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  if (!header) return;

  let lastScrollY = window.scrollY;

  const onScroll = () => {
    if (window.scrollY > 400) {
      header.classList.add('is-fixed');
    } else {
      header.classList.remove('is-fixed');
    }
  };

  window.addEventListener('scroll', onScroll);
});

document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelector('#Details-menu-drawer-container');
  const drawer = details?.querySelector('.menu-drawer');
  const summary = details?.querySelector('summary');

  if (!details || !drawer || !summary || typeof gsap === 'undefined') return;

  let isAnimating = false;

  gsap.set(drawer, {
    x: '-100%'
  });

  function lockScroll() {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden-desktop');
    document.documentElement.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden-desktop');
  }

  function unlockScroll() {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-desktop');
    document.documentElement.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden-desktop');
  }

  function openDrawer() {
    if (isAnimating || details.hasAttribute('open')) return;

    isAnimating = true;
    details.setAttribute('open', '');
    details.classList.add('is-open');
    details.classList.remove('is-closing');
    lockScroll();

    gsap.killTweensOf(drawer);
    gsap.fromTo(
      drawer,
      { x: '-100%' },
      {
        x: '0%',
        duration: 0.45,
        ease: 'power3.out',
        onComplete: () => {
          isAnimating = false;
        }
      }
    );
  }

  function closeDrawer() {
    if (isAnimating || !details.hasAttribute('open')) return;

    isAnimating = true;
    details.classList.add('is-closing');

    gsap.killTweensOf(drawer);
    gsap.to(drawer, {
      x: '-100%',
      duration: 0.4,
      ease: 'power3.inOut',
      onComplete: () => {
        details.removeAttribute('open');
        details.classList.remove('is-open', 'is-closing');
        unlockScroll();
        isAnimating = false;
      }
    });
  }

  summary.addEventListener('click', function (e) {
    e.preventDefault();

    if (details.hasAttribute('open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.menu-drawer__custom-close');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const closeSubBtn = e.target.closest('.menu-drawer__close-button');
    if (closeSubBtn && closeSubBtn.closest('#menu-drawer')) {
      // Dawn submenu close buttons sollen normal weiter funktionieren
      // daher hier nichts abfangen
    }
  });
});

function initBunnyVideos() {
  const videos = document.querySelectorAll('.custom-content-grid__video--bunny');

  if (!videos.length) return;

  videos.forEach((video) => {
    const src = video.dataset.bunnySrc;
    if (!src) return;

    if (video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      return;
    }

    if (window.Hls && window.Hls.isSupported()) {
      const hls = new window.Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
      video._hls = hls;
    }
  });
}

document.addEventListener('DOMContentLoaded', initBunnyVideos);
document.addEventListener('shopify:section:load', initBunnyVideos);

document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a[href^="http"]');

  links.forEach(link => {
    const url = new URL(link.href);

    if (url.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});